/* eslint-disable @next/next/no-img-element */
// Selo ImobTotal do rodapé dos sites de clientes — o MESMO conteúdo em todos os modelos de rodapé.
// Formato aprovado pelo Daniel em 27/09/2026 ("faixa com convite"): texto legível e um convite.
// Aba Vitrine do /leads/relatorio: o rodapé 2 (linha própria, 14px) trazia ~3,8× mais visitas por
// site que o logo com texto 11px do rodapé 1.
// 28/09: cada rodapé encaixa o selo na PRÓPRIA estrutura (mesma fonte, cor, recuo, alinhamento e
// divisória) — faixa própria nos rodapés 1 e 3, item da barra final nos rodapés 4, 5 e 6.
// Gates de sempre: `site.copyright` ligado e `tbl_sites.EsconderRodapeSobressai` desligado.
import React from 'react';
import { getImobtotalBacklink } from '../../../utils/imobtotalBacklink';
import styles from './SeloImobtotal.module.css';

const ICONE = 'https://imob.sobressai.com.br/importacoes/import_xml/xml/logo/logo_nova_1.png';

type Alinhar = 'esquerda' | 'centro';
const justify = (a?: Alinhar) => (a === 'centro' ? 'center' : a === 'esquerda' ? 'flex-start' : undefined);

export const mostraSeloImobtotal = (site: any): boolean => Boolean(site?.copyright) && !site?.EsconderRodapeSobressai;

/** Só o link (o rodapé 2 já tem a própria faixa). */
export const SeloImobtotalLink: React.FC<{ site: any; host?: string }> = ({ site, host }) => {
    const backlink = getImobtotalBacklink(site?.id, host);
    return (
        <a
            className={styles.link}
            href={backlink.href}
            target="_blank"
            rel="nofollow noopener noreferrer"
            title={backlink.title}
        >
            <img className={styles.icone} src={ICONE} alt="" width={22} height={20} loading="lazy" decoding="async" />
            <span>
                <span>Site feito pela <span className={styles.marca}>ImobTotal</span></span>
                <span className={styles.sep} aria-hidden="true">{' · '}</span>
                <span className={styles.cta}>Quer um assim para sua imobiliária?{'\u00a0'}→</span>
            </span>
        </a>
    );
};

type PropsSelo = {
    site: any;
    host?: string;
    /** alinhamento no desktop e no celular (padrão: o do desktop) */
    alinhar?: Alinhar;
    alinharMobile?: Alinhar;
    /** tamanho da letra no desktop, igual à linha de direitos do rodapé (padrão 14px) */
    fonte?: string;
};

const varsDe = (p: PropsSelo & { recuo?: string; fundo?: string; cor?: string }) =>
    ({
        '--selo-alinhar': justify(p.alinhar),
        '--selo-alinhar-mob': justify(p.alinharMobile),
        '--selo-fonte': p.fonte,
        '--selo-recuo': p.recuo,
        '--selo-fundo': p.fundo,
        '--selo-cor': p.cor,
    }) as React.CSSProperties;

/** Faixa própria de 100% de largura, com o recuo do conteúdo do rodapé e divisória opcional. */
const SeloImobtotal: React.FC<PropsSelo & { recuo?: string; fundo?: string; cor?: string; divisoria?: boolean }> = (props) => {
    const { site, host, divisoria, alinhar, alinharMobile } = props;
    if (!mostraSeloImobtotal(site)) return null;
    return (
        <div
            className={`${styles.faixa} ${divisoria ? styles.divisoria : ''}`}
            style={varsDe(props)}
            data-el="selo-imobtotal"
            data-alinhar-mob={alinharMobile ?? alinhar ?? 'esquerda'}
        >
            <SeloImobtotalLink site={site} host={host} />
        </div>
    );
};

/** Item dentro de uma barra que já existe no rodapé (herda fundo, cor, fonte e recuo dela). */
export const SeloImobtotalItem: React.FC<PropsSelo & { linhaPropria?: boolean }> = (props) => {
    const { site, host, linhaPropria, alinhar, alinharMobile } = props;
    if (!mostraSeloImobtotal(site)) return null;
    return (
        <div
            className={`${styles.item} ${linhaPropria ? styles.linhaPropria : ''}`}
            style={varsDe(props)}
            data-el="selo-imobtotal"
            data-alinhar-mob={alinharMobile ?? alinhar ?? 'esquerda'}
        >
            <SeloImobtotalLink site={site} host={host} />
        </div>
    );
};

export default SeloImobtotal;
